import RelativePositionComponent from "Component/Render/RelativePosition";
import TextComponent from "Component/Render/Text";
import Renderable from "Component/Renderable";
import Game from "Game";
import { GameObjectEvent } from "GameObject/GameObject";
import { QuitLevelPopupLayout } from "Layouts/LevelPopup/QuitLevelPopupLayout";
import { GameActions, LevelFailReason } from "State/Game/GameActions";
import { isLevelCompletedSuccessfully } from "State/Level/LevelStateHelper";
import { LevelStatus } from "State/Level/LevelStatus";
import { ProgressStateHelper } from "State/Player/Progress/ProgressStateHelper";
import { PopupID } from "State/UI/PopupID";
import { UIActions } from "State/UI/UIActions";
import BaseUISystem from "System/UI/BaseUISystem";
import { getLayout, GLayout } from "Utility/layout/LayoutHelper";
import { WorldDataHelper } from "Utility/WorldDataHelper";
import BaseMenu from "../BaseMenu";

interface QuitLevelPopupProps {
    levelNumber: number;
    endLevelClicked: boolean;
}

export class QuitLevelPopup extends BaseMenu {
    private layout: GLayout<QuitLevelPopupLayout>;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.CONFIRM_QUIT_LEVEL, uiSystem, false);
    }

    public onShow(params: QuitLevelPopupProps) {
        super.onShow(params);

        const levelNumber = params.levelNumber;

        this.layout = getLayout(QuitLevelPopupLayout);
        this.layout.root.addComponent(RelativePositionComponent, { x: 0.5, y: 0.5 });
        this.element.addChild(this.layout.root);

        const { plinkoSprite, plinkoText, underlay, levelText, quitText, keepPlayingButton, quitLevelButton, closeButton, quitButtonText } = this.layout;

        levelText.getComponent(TextComponent).text = Game.locale.getText('Level').replace('[x]', levelNumber.toString());

        if (params.endLevelClicked) {
            quitButtonText.getComponent(TextComponent).text = Game.locale.getText('EndLevelCaps');
        }

        const levelData = ProgressStateHelper.getLevelData(Game.store.getState(), levelNumber);
        const isPlinkoLevel = WorldDataHelper.isPlinkoLevel(levelNumber) && (levelData?.attempts ?? 0) <= 1;
        [
            plinkoSprite,
            plinkoText
        ].forEach(ob => {
            ob.getComponent(Renderable).visible = isPlinkoLevel;
        });

        [
            underlay,
            levelText,
            quitText
        ].forEach(ob => {
            ob.getComponent(Renderable).visible = !isPlinkoLevel;
        });

        [
            keepPlayingButton,
            closeButton
        ].forEach(ob => {
            ob.once(GameObjectEvent.SELECTED, () => { UIActions.hidePopup(this.name) });
        });

        quitLevelButton.once(
            GameObjectEvent.SELECTED,
            () => {
                if (params.endLevelClicked) {
                    const state = this.system.store.getState();

                    UIActions.showPopup(PopupID.LEVEL_POPUP, {
                        levelNumber: state.levelState.levelNumber,
                        selectedPreBoosters: state.levelState.preBoosters.filter(
                            (booster) => state.playerState.inventory[booster] > 0,
                        ),
                        failReason: LevelFailReason.NO_MORE_MATCHES,
                    });
                } else {
                    GameActions.endLevel({
                        status: LevelStatus.EXITING,
                        firstComplete: false,
                        failReason: LevelFailReason.QUIT_LEVEL,
                    })
                }
            }
        );
    }
}
